import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d06c662"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-2" }
const _hoisted_2 = { class: "d-flex flex-column gap-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "CNPJ", -1))
const _hoisted_4 = { class: "d-flex flex-column gap-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Razão Social", -1))
const _hoisted_6 = { class: "d-flex flex-column gap-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "ESTADO", -1))
const _hoisted_8 = { class: "d-flex flex-column gap-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "CONSULTOR", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_FilterBase = _resolveComponent("FilterBase")!

  return (_openBlock(), _createBlock(_component_FilterBase, {
    id: "userIpirangaFilter",
    subtitle: "Faça filtros e aprimore sua busca",
    hideFilter: false,
    staticModal: false,
    hideClose: false,
    activeModal: false,
    closeModal: _ctx.closeModal,
    disabledClick: true,
    onSearch: _ctx.enviarEmit
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_input, {
            clearable: "",
            placeholder: "Digite...",
            modelValue: _ctx.lojasValidacaoJetoilFilter.cnpj,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lojasValidacaoJetoilFilter.cnpj) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_input, {
            clearable: "",
            placeholder: "Digite...",
            modelValue: _ctx.lojasValidacaoJetoilFilter.razao_social,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lojasValidacaoJetoilFilter.razao_social) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_select, {
            filterable: "",
            placeholder: "Selecione...",
            clearable: "",
            modelValue: _ctx.lojasValidacaoJetoilFilter.estado,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lojasValidacaoJetoilFilter.estado) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayEstados, (regiao, key) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: regiao,
                  value: regiao
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_el_input, {
            clearable: "",
            placeholder: "Digite...",
            modelValue: _ctx.lojasValidacaoJetoilFilter.consultor,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.lojasValidacaoJetoilFilter.consultor) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["closeModal", "onSearch"]))
}